import styled from "styled-components/native";
import {Text} from '@fkhplus/common/src/components/atoms/Text';

export const Container = styled.View`
  align-items: center;
  justify-content: center;
  flex-direction: row;
`;

export const StyledText = styled(Text)`
`;